import React, { Component } from 'react';
import { AuthLock } from '../auth/AuthLock';

class SignUp extends Component {
    render() {
        AuthLock.getInstance().showLogIn();
        return <div />;
    }
}

export default SignUp;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/SignUp.tsx